'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(17, 17, 17, .5);\n  z-index: 9000;\n'], ['\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(17, 17, 17, .5);\n  z-index: 9000;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  overflow: hidden;\n  padding: 0px;\n  border: 1px solid red;\n  box-shadow: 0px 0px 15px -5px rgb(170,0,0,.75);\n'], ['\n  overflow: hidden;\n  padding: 0px;\n  border: 1px solid red;\n  box-shadow: 0px 0px 15px -5px rgb(170,0,0,.75);\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color:', ';\n  width: fit-content;\n  height: fit-content;\n  padding:  ', ';\n  border-radius:  ', ';\n  border: 1px solid ', ';\n  background-color: ', ';\n  box-shadow: 0px 0px 15px -5px rgb(0,0,0,.75);\n  z-index: 10000;\n  ', '\n'], ['\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color:', ';\n  width: fit-content;\n  height: fit-content;\n  padding:  ', ';\n  border-radius:  ', ';\n  border: 1px solid ', ';\n  background-color: ', ';\n  box-shadow: 0px 0px 15px -5px rgb(0,0,0,.75);\n  z-index: 10000;\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding-top:20px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n'], ['\n  padding-top:20px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  src: url(', ');\n  width: 64px;\n'], ['\n  src: url(', ');\n  width: 64px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\nwidth: 100%;\ndisplay: flex;\njustify-content: center;\ncolor: black;\nfont-weight: 400;\nfont-size: 1.1rem;\nbackground-color: #d0d0d0;\npadding: 20px;\ncursor: pointer;\nuser-select: none;\n'], ['\nwidth: 100%;\ndisplay: flex;\njustify-content: center;\ncolor: black;\nfont-weight: 400;\nfont-size: 1.1rem;\nbackground-color: #d0d0d0;\npadding: 20px;\ncursor: pointer;\nuser-select: none;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _error = require('./error.png');

var _error2 = _interopRequireDefault(_error);

var _renderprops = require('react-spring/renderprops');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Clickout = _styledComponents2.default.div(_templateObject);

var padding = function padding(props) {
  return props.padding || '20px';
};
var color = function color(props) {
  return props.color || 'black';
};
var borderRadius = function borderRadius(props) {
  return props.radius || '5px';
};
var bg = function bg(props) {
  return props.bg || 'white';
};
var border = function border(props) {
  return props.borderBg || 'black';
};
var src = function src(props) {
  return props.src;
};

var hasErrorProp = function hasErrorProp(props) {
  return props.error && (0, _styledComponents.css)(_templateObject2);
};

var Base = _styledComponents2.default.div(_templateObject3, color, padding, borderRadius, border, bg, hasErrorProp);

var ErrorHead = _styledComponents2.default.div(_templateObject4);

var Img = _styledComponents2.default.img(_templateObject5, src);

var ErrorFoot = _styledComponents2.default.div(_templateObject6);

var Modal = function Modal(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      open = _ref.open,
      bg = _ref.bg,
      color = _ref.color,
      borderBg = _ref.borderBg,
      padding = _ref.padding,
      radius = _ref.radius,
      error = _ref.error;
  return _react2.default.createElement(
    _renderprops.Transition,
    {
      items: open,
      from: { right: -200, opacity: 0 },
      enter: { right: 0, opacity: 1 },
      leave: { right: -200, opacity: 0 },
      config: { duration: 200 } },
    function (open) {
      return open && function (props) {
        return _react2.default.createElement(
          'div',
          { style: props },
          !error ? _react2.default.createElement(Clickout, { onClick: onClick }) : _react2.default.createElement(Clickout, null),
          _react2.default.createElement(
            Base,
            {
              className: className,
              error: error,
              bg: bg,
              color: color,
              borderBg: borderBg,
              padding: padding,
              radius: radius },
            !error ? _react2.default.createElement(
              _react2.default.Fragment,
              null,
              children
            ) : _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                ErrorHead,
                null,
                _react2.default.createElement(Img, { src: _error2.default })
              ),
              _react2.default.createElement(
                'div',
                { style: { padding: '20px 15px' } },
                children
              ),
              _react2.default.createElement(
                ErrorFoot,
                { onClick: onClick },
                _react2.default.createElement(
                  'p',
                  null,
                  'Dismiss'
                )
              )
            )
          )
        );
      };
    }
  );
};

exports.default = Modal;